<template>
  <div>
    <div v-if="campaign.goal" class="progress-val-wrap">
      <div class="val1 fw-600">{{completePercent(campaign)}}</div>
      <div class="val2">${{campaign.goal / 100 | formatMoney}}</div>
    </div>
    <div v-else class="progress-val-wrap">
      <div class="val1 fw-600">{{(campaign.progress.donated>0?'Ongoing':'0%')}}</div>
      <div class="val2">No Goal</div>
    </div>

    <div v-if="campaign.goal" class="progress progress-lg">
      <div class="value" v-bind:style="{ width: completePercent(campaign)}"></div>
    </div>
    <div v-else class="progress progress-lg">
      <div class="value" v-bind:style="{ width: campaign.progress.donated>0?'100%':'0%'}"></div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'CampaignProgress',
    props: ['campaign'],
    methods: {
      completePercent: function(campaign) {
        return Math.round(parseFloat(campaign.progress.donated / 100) / parseFloat(campaign.goal / 100) * 100) + '%';
      },
    },
  };
</script>
